import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IdDto } from '@services/associations/model/idDto';
import { PageCityDto } from '@services/associations/model/pageCityDto';
import { PageStreetDto } from '@services/associations/model/pageStreetDto';
import { StreetAddDto } from '@services/associations/model/streetAddDto';
import { StreetSearchDto } from '@services/associations/model/streetSearchDto';
import { StreetUpdateDto } from '@services/associations/model/streetUpdateDto';
import { PaginationModel } from '@shared/models/pagination.model';
import { Observable } from 'rxjs';
import {AllowedCountryResponse} from "@services/authentication/model/allowedCountryResponse";
import {CompanyClassifierModel} from "@services/accounting/model/companyClassifierModel";

@Injectable({
  providedIn: 'root'
})
export class DictionariesService {
  private baseUrl = environment.baseUrl;
  constructor(
    private http: HttpClient
  ) { }

  /** Get Cities For Autocomplete */
  getCities(request: string, pagination?: PaginationModel): Observable<PageCityDto> {
    const url = `${this.baseUrl}/associations/dictionaries/cities/search?page=${pagination?.number ? pagination.number : 0}&size=${pagination?.size ? pagination?.size : 50}`;
    return this.http.post<PageCityDto>(url, {name: request, activeOnly: true});
  }

  /** Get Streets */
  getStreets(request: StreetSearchDto, pagination?: PaginationModel): Observable<PageStreetDto> {
    const url = `${this.baseUrl}/associations/dictionaries/streets/search?page=${pagination?.number ? pagination.number : 0}&size=${pagination?.size ? pagination?.size : 50}`;
    return this.http.post<PageStreetDto>(url, request);
  }

  addStreet(request: StreetAddDto): Observable<IdDto> {
    const url = `${this.baseUrl}/associations/dictionaries/streets`;
    return this.http.post<IdDto>(url, request);
  }

  updateStreet(request: StreetUpdateDto): Observable<void> {
    const url = `${this.baseUrl}/associations/dictionaries/streets`;
    return this.http.put<void>(url, request);
  }

  getAllowedCountries(): Observable<AllowedCountryResponse[]> {
    const url = `${this.baseUrl}/authentication/countries`;
    return this.http.get<AllowedCountryResponse[]>(url);
  }

  searchByCode(code: string): Observable<CompanyClassifierModel> {
    const url = `${this.baseUrl}/accounting/v1/company/classifier/${code}`;
    return this.http.get<CompanyClassifierModel>(url);
  }
}
